import { useState, useEffect, useRef } from "react";
import { api } from "../api";

export default function Impostazioni() {
  const [form, setForm]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [ok, setOk]           = useState(false);
  const [errore, setErrore]   = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const fileRef = useRef();

  useEffect(() => {
    api.getImpostazioni()
      .then(d => { setForm(d); setLoading(false); })
      .catch(e => { setErrore(e.message); setLoading(false); });

    // Carica preview logo se esiste
    api.getLogoUrl && setLogoPreview(api.getLogoUrl());
  }, []);

  const salva = async () => {
    setSaving(true); setErrore(null); setOk(false);
    try { await api.setImpostazioni(form); setOk(true); }
    catch (e) { setErrore(e.message); }
    setSaving(false);
  };

  const uploadLogo = async (file) => {
    if (!file) return;
    setUploadingLogo(true);
    try {
      await api.uploadLogo(file);
      setLogoPreview(URL.createObjectURL(file));
      setOk(true);
    } catch (e) { setErrore(e.message); }
    setUploadingLogo(false);
  };

  if (loading) return <div className="loading">Caricamento...</div>;

  const inp = (chiave, label, placeholder = "", type = "text") => (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <input className="form-input" type={type} value={form[chiave] || ""}
        onChange={e => setForm({ ...form, [chiave]: e.target.value })}
        placeholder={placeholder} />
    </div>
  );

  return (
    <div className="page">
      <div className="page-header"><h1>Impostazioni</h1></div>

      {errore && <div className="errore-box">⚠️ {errore}</div>}
      {ok && <div style={{ background:"#f0fdf4", border:"1px solid #86efac", borderRadius:8, padding:"10px 16px", color:"#15803d", marginBottom:16 }}>✅ Salvato con successo</div>}

      {/* ── Dati aziendali ─────────────────────────────────────────────── */}
      <div className="card">
        <h2 className="card-title">🏢 Dati aziendali</h2>
        <p style={{ fontSize:12, color:"#64748b", marginBottom:20 }}>
          Questi dati appaiono nel frontespizio e nel footer di ogni PDF generato.
        </p>

        {/* Logo */}
        <div className="form-group" style={{ marginBottom:20 }}>
          <label className="form-label">Logo aziendale (PNG trasparente)</label>
          <div style={{ display:"flex", alignItems:"center", gap:16 }}>
            <div style={{ width:160, height:64, border:"2px dashed #e2e8f0", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", background:"#f8faff", overflow:"hidden" }}>
              {logoPreview
                ? <img src={logoPreview} alt="Logo" style={{ maxWidth:"100%", maxHeight:"100%", objectFit:"contain" }} />
                : <span style={{ fontSize:11, color:"#94a3b8" }}>Nessun logo</span>}
            </div>
            <div>
              <input type="file" accept="image/png,image/jpeg" ref={fileRef} style={{ display:"none" }}
                onChange={e => uploadLogo(e.target.files[0])} />
              <button className="btn btn-ghost" onClick={() => fileRef.current.click()} disabled={uploadingLogo}>
                {uploadingLogo ? "Caricamento..." : "📁 Carica logo"}
              </button>
              <div style={{ fontSize:10, color:"#94a3b8", marginTop:6 }}>PNG trasparente, max 2MB</div>
            </div>
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group span-2">
            <label className="form-label">Ragione Sociale *</label>
            <input className="form-input" value={form.azienda_ragione_sociale || ""}
              onChange={e => setForm({...form, azienda_ragione_sociale: e.target.value})}
              placeholder="SpeedNet WiFi S.r.l." />
          </div>
          <div className="form-group">
            <label className="form-label">P.IVA</label>
            <input className="form-input" value={form.azienda_piva || ""}
              onChange={e => setForm({...form, azienda_piva: e.target.value})}
              placeholder="01234567890" />
          </div>
          <div className="form-group">
            <label className="form-label">Iscrizione ROC</label>
            <input className="form-input" value={form.azienda_roc || ""}
              onChange={e => setForm({...form, azienda_roc: e.target.value})}
              placeholder="es. 12345" />
          </div>
          <div className="form-group span-2">
            <label className="form-label">Indirizzo sede</label>
            <input className="form-input" value={form.azienda_indirizzo || ""}
              onChange={e => setForm({...form, azienda_indirizzo: e.target.value})}
              placeholder="Via Roma 1, 00100 Roma (RM)" />
          </div>
          <div className="form-group">
            <label className="form-label">Telefono centralino</label>
            <input className="form-input" value={form.azienda_telefono || ""}
              onChange={e => setForm({...form, azienda_telefono: e.target.value})}
              placeholder="+39 0000 000000" />
          </div>
          <div className="form-group">
            <label className="form-label">Email generica</label>
            <input className="form-input" type="email" value={form.azienda_email || ""}
              onChange={e => setForm({...form, azienda_email: e.target.value})}
              placeholder="info@speednetwifi.it" />
          </div>
          <div className="form-group">
            <label className="form-label">PEC</label>
            <input className="form-input" value={form.azienda_pec || ""}
              onChange={e => setForm({...form, azienda_pec: e.target.value})}
              placeholder="pec@speednetwifi.it" />
          </div>
          <div className="form-group">
            <label className="form-label">Sito web</label>
            <input className="form-input" value={form.azienda_sito || ""}
              onChange={e => setForm({...form, azienda_sito: e.target.value})}
              placeholder="www.speednetwifi.it" />
          </div>
        </div>
      </div>

      {/* ── Preventivi ─────────────────────────────────────────────────── */}
      <div className="card">
        <h2 className="card-title">📄 Impostazioni preventivi</h2>
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Validità preventivo (giorni)</label>
            <input className="form-input" type="number" min="1" max="365"
              value={form.validita_giorni || "30"}
              onChange={e => setForm({...form, validita_giorni: e.target.value})} />
          </div>
        </div>
      </div>

      {/* ── Soglie approvazione ────────────────────────────────────────── */}
      <div className="card">
        <h2 className="card-title">🔐 Soglie approvazione sconto</h2>
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Soglia Responsabile (%)</label>
            <input className="form-input" type="number" min="0" max="100"
              value={form.soglia_responsabile || ""}
              onChange={e => setForm({...form, soglia_responsabile: e.target.value})} />
            <small style={{ color:"#94a3b8", fontSize:11, marginTop:4 }}>
              Sconto ≥ questa soglia → richiede approvazione Responsabile
            </small>
          </div>
          <div className="form-group">
            <label className="form-label">Soglia Dirigente (%)</label>
            <input className="form-input" type="number" min="0" max="100"
              value={form.soglia_dirigente || ""}
              onChange={e => setForm({...form, soglia_dirigente: e.target.value})} />
            <small style={{ color:"#94a3b8", fontSize:11, marginTop:4 }}>
              Sconto ≥ questa soglia → richiede approvazione Dirigente
            </small>
          </div>
        </div>
      </div>

      {/* ── SMTP ───────────────────────────────────────────────────────── */}
      <div className="card">
        <h2 className="card-title">📧 Configurazione email (SMTP)</h2>
        <p style={{ fontSize:12, color:"#64748b", marginBottom:20 }}>
          Usato per notifiche approvazioni. Lascia vuoto per disabilitare.
        </p>
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Server SMTP</label>
            <input className="form-input" value={form.smtp_host || ""}
              onChange={e => setForm({...form, smtp_host: e.target.value})} placeholder="smtp.gmail.com" />
          </div>
          <div className="form-group">
            <label className="form-label">Porta</label>
            <input className="form-input" type="number" value={form.smtp_port || ""}
              onChange={e => setForm({...form, smtp_port: e.target.value})} placeholder="587" />
          </div>
          <div className="form-group">
            <label className="form-label">Utente SMTP</label>
            <input className="form-input" value={form.smtp_user || ""}
              onChange={e => setForm({...form, smtp_user: e.target.value})} placeholder="noreply@speednetwifi.it" />
          </div>
          <div className="form-group">
            <label className="form-label">Password SMTP</label>
            <input className="form-input" type="password" value={form.smtp_pass || ""}
              onChange={e => setForm({...form, smtp_pass: e.target.value})} placeholder="••••••••" />
          </div>
          <div className="form-group span-2">
            <label className="form-label">Indirizzo mittente</label>
            <input className="form-input" value={form.smtp_from || ""}
              onChange={e => setForm({...form, smtp_from: e.target.value})} placeholder="Preventivi SpeedNet <noreply@speednetwifi.it>" />
          </div>
        </div>
      </div>

      <div style={{ display:"flex", justifyContent:"flex-end" }}>
        <button className="btn btn-primary" onClick={salva} disabled={saving}>
          {saving ? "Salvataggio..." : "💾 Salva impostazioni"}
        </button>
      </div>
    </div>
  );
}
